export default {
  title: 'Código promocional',
  fields: {
    preset: {
      label: 'Predefinição',
    },
    presets: {
      master: 'Mestre',
      campaign: 'Campanha',
      one_time: 'Uma vez',
    },
    code: {
      label: 'Código',
      placeholder: 'Introduzir código',
    },
    discount_type: {
      label: 'Tipo de desconto',
    },
    quantity: {
      label: 'Quantidade',
      placeholder: 'Infinito',
    },
    expires_at: {
      label: 'Data de expiração',
      placeholder: 'Introduza uma data ou deixe em branco',
    },
    franchise: {
      label: 'Código promocional principal para o restaurante e/ ou em toda a marca',
    },
    discount: {
      label: 'Desconto',
    },
    usage_threshold: {
      label: 'Limiar de utilização',
    },
  },
  messages: {
    master_warning: 'Criar um novo código promocional «mestre» irá expirar o código promocional mestre atual',
  },
  buttons: {
    save: 'Guardar',
    cancel: 'Cancelar',
  },
  toasts: {
    promo_code_got_created: 'Código promocional criado',
    promo_code_got_updated: 'Código promocional atualizado',
  },
};
